import { ITEM_STATE_LOADING, ITEM_STATE_PLACEHOLDER } from "../../constants";
import updateLoadingItemState from "./updateLoadingItemState";

const createIndicativeLoadingItems = items =>
  [...new Array(items.length)].map((_, i) => ({
    id: `${ITEM_STATE_LOADING}_${i}`,
    itemState: ITEM_STATE_LOADING
  }));

const sortIntent = ({ items, ...rest }, { payload: sortOption }) => ({
  ...rest,
  indicatives: {
    ...sortOption,
    items: createIndicativeLoadingItems(items)
  },
  items: updateLoadingItemState(items, ITEM_STATE_PLACEHOLDER)
});

export default sortIntent;
